import { Percent } from "@/components/l10n/Percent.tsx";
import { VatText } from "@/components/VatText.tsx";
import { getIsCreditNote } from "@/modules/billing/invoice/invoiceLogic.tsx";
import type { BillingAccountInvoice } from "@warrenio/api-spec/spec.oats.gen";
import { Fragment } from "react";

export function VatFieldTitle({ invoice }: { invoice: BillingAccountInvoice }) {
    const isCreditNote = getIsCreditNote(invoice);
    if (isCreditNote) {
        // we don't show percent as credit notes can have multiple VAT components and showing percent doesn't make sense
        return <VatText />;
    }

    const { vat_percentage, vat_components } = invoice;
    return vat_components ? (
        <>
            <VatText /> (
            {vat_components.map((c, index) => (
                <Fragment key={`${c.amount}-${index}`}>
                    {index > 0 ? "+" : null}
                    <Percent value={c.amount} />
                </Fragment>
            ))}
            )
        </>
    ) : (
        <>
            <VatText /> (<Percent value={vat_percentage} />)
        </>
    );
}
